module.exports = __webpack_public_path__ + "img/homepage-bottom-cta@3x.115b625.jpg";